import template from './_map-label.pug'



// @vue/component
export default {
  template: template(),
  
  props: {
    routeData: {
      type: Object,
      default: undefined
    }
  },

  computed:{
    hasTransit(){
        return this.routeData.steps.some((step) => step.travel_mode === 'TRANSIT' && step.transit && step.transit.line);
    }
  },
  methods: {

    stepLineName(step) {
      const {short_name: shortName, name} = _.get(step, 'transit.line')
      return shortName || name
    },

    stepStyle(step) {
      return {
        color: step.transit.line.text_color,
        'background-color': step.transit.line.color
      }
    },
  }
}
